export default "__VITE_PUBLIC_ASSET__f093580e__"